import React, { useState, useEffect } from 'react';
import { IonIcon } from '@ionic/react';
import { chevronDown, chevronForward, closeOutline } from 'ionicons/icons';
import './CollapsibleCard.css';

const CollapsibleCard = ({ 
  title,
  subtitle,
  icon,
  children,
  defaultExpanded = false,
  onToggle,
  headerActions,
  showHeaderActionsOnlyWhenExpanded = false,
  lazyLoad = false,
  fullScreenMode = false,
  className = ''
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [hasLoadedContent, setHasLoadedContent] = useState(!lazyLoad || defaultExpanded);

  useEffect(() => {
    if (fullScreenMode && isExpanded) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isExpanded, fullScreenMode]);

  const handleToggle = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);
    
    if (lazyLoad && !hasLoadedContent && newExpandedState) {
      setHasLoadedContent(true);
    }
    
    if (onToggle) {
      onToggle(newExpandedState);
    }
  };

  const cardClassName = `collapsible-card ${className} ${
    fullScreenMode && isExpanded ? 'collapsible-card-fullscreen' : ''
  }`.trim();

  return (
    <div className={cardClassName}>
      <div className="collapsible-card-header" onClick={!fullScreenMode || !isExpanded ? handleToggle : undefined}>
        <div className="collapsible-card-header-left">
          <button 
            className="collapsible-toggle-btn"
            onClick={fullScreenMode && isExpanded ? (e) => { e.stopPropagation(); handleToggle(); } : undefined}
            aria-expanded={isExpanded}
            aria-label={isExpanded ? 'Collapse section' : 'Expand section'}
          >
            <IonIcon icon={isExpanded ? chevronDown : chevronForward} />
          </button>
          
          {icon && (
            <div className="collapsible-card-icon">
              <IonIcon icon={icon} />
            </div>
          )}
          
          <div className="collapsible-card-title-group">
            <h2 className="collapsible-card-title">{title}</h2>
            {subtitle && !isExpanded && (
              <p className="collapsible-card-subtitle">{subtitle}</p>
            )}
          </div>
        </div>
        
        {fullScreenMode && isExpanded && (
          <div className="collapsible-card-fullscreen-actions">
            {headerActions}
            <button 
              className="collapsible-card-close-btn"
              onClick={handleToggle}
              aria-label="Close full screen"
            >
              <IonIcon icon={closeOutline} />
            </button>
          </div>
        )}
        
        {headerActions && (!showHeaderActionsOnlyWhenExpanded || isExpanded) && !fullScreenMode && (
          <div 
            className="collapsible-card-header-actions"
            onClick={(e) => e.stopPropagation()}
          >
            {headerActions}
          </div>
        )}
      </div>
      
      {isExpanded && (
        <div className="collapsible-card-content">
          {hasLoadedContent ? children : null}
        </div>
      )}
    </div>
  );
};

export default CollapsibleCard;
